import { axios, HOST, config } from "./settiing";

export default {
  getGroupList(params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(`${HOST}/resource/groupList?${query}`, config);
  },
  getGroupDetailList(groupId) {
    return axios.get(`${HOST}/resource/groupDetail/${groupId}`, config);
  },
  getJoinedGroupDetailList(customerId) {
    return axios.get(`${HOST}/resource/group/customer/${customerId}`, config);
  },
};
